import React from 'react';

const badgeStyle = { fontSize: '0.8rem', padding: '6px 10px' };

export default function InfoBadge({ icon, text, secondaryText }) {
  return (
    <span className='badge bg-light text-dark border' style={badgeStyle}>
      <i className={`${icon || 'fa-solid fa-circle-info'} text-primary me-1`}></i>
      {text}
      {secondaryText && <span className='text-muted ms-1'>({secondaryText})</span>}
    </span>
  );
}
